import { Injectable } from '@angular/core';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import {
    RepositoryService,
    FilterParams,
    FilterResult,
} from '../../../helpers/crud/repository.service';
import { HasId } from '../../../helpers/crud/edit/HasId';
import { ClientFaceDetail, ClientFaces, WancomFaces } from '../../park/park.model';

@Injectable()
export class ScreenLocationService extends RepositoryService<OrganizationLocationsInfo> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'screenLocations');
    }

    public setPlaylistOrder(faceId: number, newOrderSpotList: Array<number>) {
        return this.http.post(
            `${this.url}/setPlaylistOrder/${faceId}`,
            newOrderSpotList
        );
    }

    public removeFaceFromCampaign(diffusionId: number, faceId: number) {
        const bodyParams: RemoveFaceFromCampaignContent =
            new RemoveFaceFromCampaignContent();
        bodyParams.faceId = faceId;
        return this.http.post(
            `${this.url}/removeFaceFromCampaign/${diffusionId}`,
            bodyParams
        );
    }

    public removeWancomDiffFromFace(diffusionId: number, faceId?: number, screenId?: number) {
        const bodyParams: RemoveFaceFromCampaignContent =
            new RemoveFaceFromCampaignContent();
        bodyParams.faceId = faceId;
        // Inutile d'ajouter le screen si on a déjà la faceId
        // bodyParams.screenId = screenId;
        return this.http.post(
            `${this.url}/removeWancomDiffFromFace/${diffusionId}`,
            bodyParams
        );
    }

    public getFaceClient(screenLocationFilter: any) {
        return this.http.post<ClientFaces[]>(`${this.url}/getFaceClient`, screenLocationFilter);
    }

    public getFaceWancom(screenLocationFilter: any) {
        return this.http.post<WancomFaces[]>(`${this.url}/getFaceWancom`, screenLocationFilter);
    }

    /**
     * @deprecated
     */
    public getFace(screenLocationFilter: any) {
        return this.http.post<any>(`${this.url}/getFace/`, screenLocationFilter);
    }

    public getFaceMap(screenLocationFilter: any) {
        return this.http.post<GetFaceMapOutPut[]>(`${this.url}/getFaceMaps/`, screenLocationFilter);
    }

    public getFaceSelection(screenLocationFilter: any) {
        return this.http.post<any>(
            `${this.url}/getFaceSelection/`,
            screenLocationFilter
        );
    }
}


export class ScreenLocationFilter extends FilterParams {
    organizationId: number;
    spotId?: number;
    diffDetail: boolean;
    dontOrder?: boolean;
    deleted?: boolean;
}

class RemoveFaceFromCampaignContent {
    faceId: number;
    screenId?: number;
}

class OrganizationLocationsInfo implements HasId {
    id: number; // id de l'orga
    organizationName: string;

    locations: LocationModelInfo[];
}

export class LocationModelInfo {
    id?: number;
    name?: string;
    img?: string;
    faces: LocationFaceModel[];
}

export class LocationFaceModel {
    id: number;
    name: string;
    img?: number;
    desc: string;
    formatTypeId: number;
    notCompatibleWithThisSpot: boolean;
    canCreateCampaign: boolean;
    actualDiffs: DiffProjectionModel[];
    futuresDiffs: DiffProjectionModel[];

    seeFutureDiff: boolean;
    futureDiffCount: number;

    selected: boolean;
}

class DiffProjectionModel {
    id: number;
    diffId: number;
    name: string;

    progression: string;

    spotId: number;
    file: any;
    thumbnailId: number;
    fill: number;
    templateRefId: number;
    nbDays: number;
    otherScreens: number;
    weekDays: number[];
    beginHour: any;
    endHour: any;
    minTemp: number;
    maxTemp: number;
    weather: number;

    dayString: string;

    canModify: boolean;
    isProtected: boolean;
    isLocked: boolean;
    isDisabled: boolean;
    generationStatus: number;
}

export interface GetFaceMapOutPut {
    screenParkId: number;
    gpsLatitude: number;
    gpsLongitude: number;
    faces: FaceMapOutPut[];
}

interface FaceMapOutPut {
    faceId: number;
    gpsLatitude: number;
    gpsLongitude: number;
}

